import React from "react";

function About() {
  return (
    <section id="about" className="grid">
      <h3 className="title about-me">About Me</h3>
      <p className="leading about-text">
        Hey, I'm Tarun — a software engineer passionate about building intelligent, end-to-end web applications.  
  I specialize in blending AI/ML systems with full-stack product development. With industry experience and academic roots in Intelligent Systems from UTD, I focus on solving real-world problems by taking ideas from concept to deployment.  
  I enjoy working across the stack, learning new tools quickly, and building products that actually ship.
      </p>

      <div className="highlights grid">
        <div id="highlight" className="highlight-card">
          <h3 className="exp">2+ Years</h3>
          <p className="highlight-text">Software Engineering Experience</p>
        </div>
        <div id="highlight2" className="highlight-card">
          <h3 className="exp">10+ Apps</h3>
          <p className="highlight-text">AI & Full-Stack Projects Built</p>
        </div>
        <div id="highlight3" className="highlight-card">
          <h3 className="exp">End-to-End</h3>
          <p className="highlight-text">From Idea → ML → Product</p>
        </div>
      </div>

      <div className="skill-title">Languages</div>
      <div className="skills-wrapper">
        <div className="skills-slide-left">
          <div className="icon">
            <i class="devicon-python-plain-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-javascript-plain"></i>
          </div>
          <div className="icon">
            <i class="devicon-java-plain-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-dart-plain-wordmark"></i>
          </div>
        </div>
        <div className="skills-slide-left">
          <div className="icon">
            <i class="devicon-python-plain-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-javascript-plain"></i>
          </div>
          <div className="icon">
            <i class="devicon-java-plain-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-dart-plain-wordmark"></i>
          </div>
        </div>
      </div>

      <div className="skill-title">Libraries & Frameworks</div>
      <div className="skills-wrapper">
        <div className="skills-slide-right">
        <div className="icon">
        <i class="devicon-wordpress-plain-wordmark"></i>
          
        </div>
        <div className="icon">
            <i class="devicon-php-plain"></i>
          </div>
          <div className="icon">
            <i class="devicon-react-original-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-angular-plain-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-nodejs-plain-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-spring-original-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-vuejs-plain-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-flutter-plain"></i>
          </div>
        </div>
        <div className="skills-slide-right">
        <div className="icon">
        <i class="devicon-wordpress-plain-wordmark"></i>
          
        </div>
        <div className="icon">
            <i class="devicon-php-plain"></i>
          </div>
          <div className="icon">
            <i class="devicon-react-original-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-angular-plain-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-nodejs-plain-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-spring-original-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-vuejs-plain-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-flutter-plain"></i>
          </div>
        </div>
      </div>
      <div className="skill-title">Technologies</div>
      <div className="skills-wrapper">
        <div className="skills-slide-left">
          <div className="icon">
            <i class="devicon-mysql-plain-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-mongodb-plain-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-postgresql-plain-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-firebase-plain-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-docker-plain-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-jenkins-plain"></i>
          </div>
        </div>
        <div className="skills-slide-left">
          <div className="icon">
            <i class="devicon-mysql-plain-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-mongodb-plain-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-postgresql-plain-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-firebase-plain-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-docker-plain-wordmark"></i>
          </div>
          <div className="icon">
            <i class="devicon-jenkins-plain"></i>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
